import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectUserETHAddresses,
  selectUserETHAddressesLoading,
  selectUserETHAddressesState,
  useFetchUserETHAddressesQuery,
  useLazyFetchUserETHAddressesQuery,
} from '../actions/fetchUserETHAddresses';

export interface IUseUserETHAddressesProps extends IUseQueryProps {}

export const useUserETHAddresses = ({
  skipFetching,
}: IUseUserETHAddressesProps) => {
  useFetchUserETHAddressesQuery(
    getQueryParams({ params: undefined, skipFetching }),
  );

  const [handleFetchUserETHAddresses] = useLazyFetchUserETHAddressesQuery();

  const userETHAddresses = useAppSelector(selectUserETHAddresses);

  const loading = useAppSelector(selectUserETHAddressesLoading);

  const state = useAppSelector(selectUserETHAddressesState);

  return { handleFetchUserETHAddresses, loading, userETHAddresses, state };
};
